import { Link } from "react-router-dom"
import { useAuth } from "../hooks/useAuth"

export default function SiteMenu({ logo }) {
    const isLoggedIn = useAuth()

    // Signed-in users get these options from the user menu, so the logo is
    // just a link home for them.
    if (isLoggedIn) {
        return (
            <div className="ps-5 w-50">
                <Link
                    to="/"
                    className="d-flex align-items-center col-lg-4 mb-2 mb-lg-0 link-body-emphasis text-decoration-none ps-4"
                >
                    <img src={logo} alt="Chaperon home" width={100} />
                </Link>
            </div>
        )
    }

    return (
        <div className="dropdown ps-5 w-50">
            <a
                href="/"
                className="d-flex align-items-center col-lg-4 mb-2 mb-lg-0 link-body-emphasis text-decoration-none dropdown-toggle ps-4"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <img src={logo} alt="logo" width={100} />
            </a>
            <ul className="dropdown-menu text-small shadow">
                <li>
                    <Link className="dropdown-item active" to={`/`}>
                        Home
                    </Link>
                </li>
                <li>
                    <a
                        className="dropdown-item"
                        href="https://getchaperon.com/about"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        About us
                    </a>
                </li>
                <li>
                    <Link className="dropdown-item" to={`/pricing`}>
                        Plans & pricing
                    </Link>
                </li>
                <li>
                    <Link className="dropdown-item" to={`/contact`}>
                        Contact us
                    </Link>
                </li>
                <li>
                    <hr className="dropdown-divider" />
                </li>
                <li>
                    <a className="dropdown-item disabled" href="/community">
                        Open app
                    </a>
                </li>
                <li>
                    <a className="dropdown-item disabled" href="/">
                        Download apps
                    </a>
                </li>
            </ul>
        </div>
    )
}
